import { QueryClientProvider } from "@tanstack/react-query";
import React from "react";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { IS_DEV_ENV } from "../shared/constants/environment";
import { WSQueryClient } from "@ws-react-query";

type Props = {
  hideDevTools?: boolean;
};

export const WSQueryProvider: React.FC<Props> = props => {
  return (
    <QueryClientProvider client={WSQueryClient}>
      {props.children}
      {IS_DEV_ENV && !props.hideDevTools ? (
        <ReactQueryDevtools initialIsOpen={false} />
      ) : null}
    </QueryClientProvider>
  );
};
